  <ng-container *ngIf="user$ | async as user; else login">
    <cx-page-slot position="HeaderLinks"></cx-page-slot>
  </ng-container>

  <ng-template #login>
    <a role="link" [routerLink]="{ cxRoute: 'login' } | cxUrl"><i class="icon-ico-user-color" [attr.data-text]="'login.btnTitle' | cxTranslate"></i></a>
  </ng-template>
